export const intialSteelData = {
  id: "",
  firstName: "",
  lastName: "",
  emailId: "",
  roleId: "",
  locationId: "",
  status: "0",
};
